import type { ConnectionLineComponent } from '@xyflow/react';

export const ConnectionLine: ConnectionLineComponent = ({
  fromX,
  fromY,
  toX,
  toY,
}) => (
  <g>
    <path
      fill="none"
      stroke="var(--primary)"
      strokeWidth={2.5}
      strokeDasharray="6 4"
      strokeLinecap="round"
      // 关键：用屏幕像素宽度，避免缩小画布时线宽 < 1px 而“看不见”。
      vectorEffect="non-scaling-stroke"
      className="fm-connection-line"
      d={`M${fromX},${fromY} C ${fromX + (toX - fromX) * 0.5},${fromY} ${fromX + (toX - fromX) * 0.5},${toY} ${toX},${toY}`}
    />
    <circle
      cx={toX}
      cy={toY}
      fill="var(--primary)"
      r={3}
      stroke="#fff"
      strokeWidth={1.5}
      vectorEffect="non-scaling-stroke"
    />
  </g>
);
